import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ROUTES } from "../../../constants/routes";
import { Box, Card, CardContent, TextField, Typography } from "@material-ui/core";
import { Row, Col } from "react-bootstrap";
import { InputDatePicker, InputField, InputSelectField } from "../../../common-components/FormComponent/FormFieldsComponent";
import { CancelButtonComponent } from "../../../common-components/ButtonComponent";
import { CircularProgress } from "@mui/material";
import CommonHeadPart from "../../../common-components/CommonHeadPart";
import DashboardIcon from "../../../svg_icons/dashboard.svg";
import * as Actions from "../../../reducer-store/actions/StudentContractAction";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import ToastMessage from "../../../common-components/ToastMessage";
import { useParams } from "react-router-dom";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { contracts } from "../../../reducer-store/constants";

const useStyles = makeStyles(() => ({
  CardTitle: {
    backgroundColor: "#646464",
    color: "#ffffff",
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  }
}));

const ViewStaffInstructor: React.FC = () => {
  const classes = useStyles();
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValidValues, setIsValidValues] = useState(true);
  const [contractType, setContractType] = useState("");
  const [documentName, setDocumentName] = useState("");
  const { SingleStudentContaract } = Actions;
  const AuthToken = useSelector((state: any) => state.auth);
  const { token } = AuthToken;
  const params: any = useParams();
  const { id } = params;
  const [saveUpdate, setSaveUpdate] = useState(true)

  useEffect(() => {
    (async () => {
      if (params && params.id) {
        const response: any = await SingleStudentContaract(id, token);
        const data = response.data;
        setDocumentName(data && data.contract_name);
        setContractType(data && data.contract_description);
        setSaveUpdate(false)
      }
    })();
  }, [id]);

  if (params && params.id && saveUpdate) {
    return <>
      <Box style={{ position: 'absolute', margin: '0 auto', top: '50%', left: '50%', justifyContent: 'center' }}>
        <CircularProgress sx={{ color: '#707070' }} />
      </Box></>
  }

  const BreadCrumbStudentContractManagement = [
    {
      labelText: "Home",
      linkUrl: ROUTES.dashboard,
    },
    {
      labelText: "View Terms and Contracts",
      linkUrl: ROUTES.studentContractManagement,
    },
  ];

  return (
    <>
      <ToastMessage />
      <Row>
        <Col lg="8" sm="12">
          <CommonHeadPart
            componentText="Student Contract"
            Icon={DashboardIcon}
            buttonText=""
            urlLink="/"
            BreadCrumbs={BreadCrumbStudentContractManagement}
          />
        </Col>
      </Row>

      <Card>
        <div className={classes.CardTitle}>
          <CardContent>
            <Typography variant="h6" align="justify">
              {/*  <AddCircle /> */}
              View Terms and Contracts
            </Typography>
          </CardContent>
        </div>
        <CardContent>
          <form>
            <Row>
              <Col lg="4" sm="12">
                <InputSelectField
                  select={true}
                  lable="Contract Type"
                  name="type"
                  value={contractType}
                  className="form-textfield-styles"
                  options={contracts}
                  handleChange={(e) => setContractType(e.target.value)}
                  isValidValue={isValidValues}
                  isSubmit={isSubmit}
                  requiredMessage="Contract Type field is required"
                  disabled
                />
              </Col>
              <Col lg="4" sm="12">
                <InputField
                  type="text"
                  lable="Document Name"
                  name={documentName}
                  rows={1}
                  multiline={true}
                  placeHolder="Enter Document Name"
                  className="form-textfield-styles"
                  value={documentName}
                  handleChange={(e) => setDocumentName(e.target.value)}
                  isValidValue={isValidValues}
                  isSubmit={isSubmit}
                  requiredMessage="Document Name is required"
                  disabled
                />
              </Col>
              <Col lg="4" sm="12">
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  type="file"
                  label="Upload Document (PDF Only)"
                  className="form-textfield-styles errorBottom"
                  onChange={(e) => { }}
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col lg="4" sm="12">
                <InputDatePicker
                  disabled={true}
                  className="form-textfield-styles errorBottom"
                  value={moment(new Date()).format("YYYY-MM-DD")}
                  lable="Date Created"
                  handleChange={(e) => { }}
                  isValidValue={false}
                  isSubmit={false}
                  requiredMessage="Date Created is required"
                />
              </Col>
              <Col lg="4" sm="12">
                <Col lg="4" sm="12">
                  <FormControlLabel
                    disabled
                    control={
                      <Checkbox
                        // disabled={editProgramInfo === undefined ? true : false}
                        checked={false}
                        onChange={() => { }}
                        color="success"
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                      />
                    }
                    label="Is Mandatory"
                  />
                </Col>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col lg="12" sm="12">
                <div style={{ textAlign: "end" }}>
                  <Link to={ROUTES.studentContractManagement} className={classes.link}>
                    <CancelButtonComponent ButtonLabel="Cancel" /></Link>{" "}
                </div>
              </Col>
            </Row>
          </form>
        </CardContent>
      </Card>
    </>
  );
};

export default ViewStaffInstructor;
